import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

interface DeleteAccountModalProps {
  open: boolean;
  onCancel: () => void;
}
export default function UnableToDeleteModal({ open, onCancel }: DeleteAccountModalProps) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      title={t("myAccount.deleteAccount.unableModal.title")}
      footer={[
        <Button key="ok" type="primary" onClick={onCancel}>
          {t("myAccount.deleteAccount.unableModal.okCTA")}
        </Button>
      ]}
    >
      <div>{t("myAccount.deleteAccount.unableModal.msg")}</div>
    </Modal>
  );
}
